// message.js
export default {
    en: {
        common: {
            action: "Save",
            contact_name: "Contact Name",
            address: "Address",
            phone: "Phone",
            city: "City",
            province: "Province",
            postal_code: "Postal Code",
            ownership_type: "Ownership Type",
        },
        merchant_details: {
            title: "Merchant DBA Info",
            merchant_type: "Industry Category",
            dba_name: "DBA Name",
            industry: "Industry",
            previous_processor: "Previous Processor",
            language: "Language",
            dba_address: "DBA Address",
            dba_phone: "DBA Phone",
            cell_phone: "Cell Phone",
            alt_phone: "Alt Phone",
            alt_phone_2: "Alt Phone 2",
            alt_phone_note: "Alt Phone Note",
            awb_number: "AWB Number",
            monthly_volume: "Monthly Credit Volume",
            monthly_volume_other: "Custom",
            monthly_volume_custom: "Custom amount",
            monthly_volume_custom_default_hint: "If empty, default $25,000 will be stored.",
            email_address: "Email Address",
            company: "Company",
            notes: "Notes",
            add_a_note: "Add a note...",
            quick_add: "Quick Add",
            office: "Office",
            request_ownership: "Request Ownership",
            delete_lead: "Delete Lead",
            ownership_request_note: "If the Ownership Request is accepted, this lead will remain unchanged.",
            save_anyway: "Save Anyway",
            lead_exists_note: "This Lead already exists in this Office.",
            lead_exists_note_request_ownership: "This lead already exists in the office. Do you want to request ownership?",
            save_lead: "Save Lead",
            warm_transfer: "Warm Transfer",
            live_transfer: "Live Transfer",
            choose_closer: "Choose Closer",
            select_one: "Select One",
            note: "Note: Warm and Live transfers are available only to Openers",
            submit: "Submit"
        },
        principal_info: {
            principal_info: "Principal Info",
            add_principal_info: "Add Principal Info",
            principal_no: "Principal No",
            title: "Title",
            ownership_percentage: "Ownership Percentage (%)",
            basic_details: "Basic Details",
            first_name: "First Name",
            middle_name: "Middle Name",
            last_name: "Last Name",
            home_phone: "Home Phone",
            cell_phone: "Cell Phone",
            email: "Email",
            date_of_birth: "Date Of Birth",
            previous_address: "Previous Address (if current address is less than 2 years)",
            identity_details: "Identity Details",
            id_verification_method: "ID Verification Method",
            id_type: "ID Type",
            document_number: "Document Number",
            document_issue_date: "Document Issue Date",
            document_expiry_date: "Document Expiry Date",
            country_of_citizenship_1: "Country Of Citizenship 1",
            country_of_citizenship_2: "Country Of Citizenship 2",
            residency: "Residency",
            residency_note: "If the Principal has citizenship in more than two countries and one is the United States, please ensure to select United States for Country of Citizenship 1 or Country of Citizenship 2.",
            
        },
        other_merchant_info: {
            title: "Other Merchant Info",
            add_info: "Add Other Merchant Info",
            type: "Type",
            gst_tax_id: "GST Tax ID",
            sin: "SIN",
            sin_number: "SIN number",
            business_number: "Business Registration Number",
            ownership_type: "Ownership Type",
            mcc: "MCC",
            description_of_services_offered: "Description of Services Offered",
            settlement_currency: "Settlement Currency",
            year_established: "Year Established",
            ownership_months: "Ownership Months",
            ownership_years: "Ownership Years",
            country_of_formation: "Country of Formation",
            country_of_primary_business_operations: "Country of Primary Business Operations"
        },
        bank_account: {
            title: "Bank Account",
            add_info: "Add Bank Info",
            bank_account_holder_name: "Bank Account Holder Name",
            billing_account: "Billing Account",
            bank_name: "Bank Name",
            bank_type: "Bank Type",
            transit_number: "Transit No. #",
            dda_account_number: "DDA Account No. #",
            city: "City",
            province: "Province",
            postal_code: "Postal Code"
        },
        payroll_info: {
            title: "Bank Account",
            add_info: "Add Bank Info",
            billing_account: "Billing Account",
            bank_name: "Bank Name",
            bank_type: "Bank Type",
            transit_number: "Transit No. #",
            dda_account_number: "DDA Account No. #",
            sin: "SIN No.",
            dob: "Date of Birth",
            hourly_wage: "Hourly Wage",
            annual_salary: "Annual Salary",
            city: "City",
            province: "Province",
            postal_code: "Postal Code"
        },
        financial_info: {
            title: "Financial Info",
            add_info: "Add Financial Info",
            revenue_transactions: "Revenue & Transactions",
            avg_transaction_amount: "Avg Transaction Amount",
            highest_avg_ticket: "Highest Avg Ticket",
            highest_avg_ticket_frequency: "Highest Avg Ticket Frequency",
            projected_monthly_card_sales: "Projected Monthly Card Sales",
            company_annual_revenue: "Company Annual Revenue",
            seasonal_months_closed: "Seasonal Months Closed",
            seasonal_business: "Seasonal Business?",
            language_preferences: "Language Preferences",
            back_office_service_language: "Back Office Service Language",
            pos_service_language: "POS Service Language",
            card_acceptance_per_channel: "Card Acceptance (per channel)",
            website: "Website",
            card_present: "Card Present (CP) %",
            card_not_present: "Card Not Present (CNP) %",
            internet: "Internet (INT) %",
            industry_type: "Industry Type",
            card_swipe_chip_percent_nuvei: "Card Swipe/Chip",
            ecomm_percent_nuvei: "EComm",
            moto_percent_nuvei: "MOTO/Keyed",
            save: "Save"
        },
        legal_info: {
            title: "Legal Entity Info",
        },
        shipping_legal_address: {
            title: "Shipping / Other Address",
            add_address: "Add Address",
            other_address: "Other Address",
            address_type: "Address Type",
            dba_name: "DBA Name (or Location Name)",
            contact_name: "Contact Name",
            phone: "Phone",
            ext: "Ext",
            fax: "Fax",
            address: "Address",
            city: "City",
            province: "Province",
            postal_code: "Postal Code"
        }
    },
    
    fr: {
        common: {
            action: "Enregistrer",
            contact_name: "Nom du contact",
            address: "Adresse résidentiel",
            phone: "Téléphone",
            city: "Ville",
            province: "Province",
            postal_code: "Code postal",
            ownership_type: "Type de propriété",
        },
        merchant_details: {
            title: "Informations sur le commerçant",
            merchant_type: "Industry Category",
            dba_name: "Nom de l'entreprise",
            industry: "Industrie",
            previous_processor: "Processeur précédent",
            language: "Langue",
            dba_address: "Adresse de l'entreprise",
            dba_phone: "Téléphone de l'entreprise",
            cell_phone: "Téléphone cellulaire",
            alt_phone: "Téléphone alternatif",
            alt_phone_2: "Téléphone alternatif 2",
            alt_phone_note: "Alt Phone Note",
            awb_number: "Numéro AWB",
            monthly_volume: "Volume mensuel",
            monthly_volume_other: "Personnalisé",
            monthly_volume_custom: "Montant personnalisé",
            monthly_volume_custom_default_hint: "Si vide, la valeur par défaut de 25 000 $ sera enregistrée.",
            email_address: "Adresse courriel",
            company: "Société",
            notes: "Remarques",
            add_a_note: "Ajouter une note...",
            quick_add: "Ajout rapide",
            office: "Bureau",
            request_ownership: "Demander la propriété",
            delete_lead: "Supprimer le prospect",
            ownership_request_note: "Si la demande de propriété est acceptée, ce prospect restera inchangé.",
            save_anyway: "Enregistrer quand même",
            lead_exists_note: "Ce prospect existe déjà dans ce bureau.",
            lead_exists_note_request_ownership: "Ce prospect existe déjà dans ce bureau. Voulez-vous demander la propriété ?",
            save_lead: "Enregistrer le prospect",
            warm_transfer: "Transfert",
            live_transfer: "Transfert direct",
            choose_closer: "Choisissez un représentant",
            select_one: "Sélectionnez-en un",
            note: "Remarque : Les transferts et les transferts en direct sont disponibles uniquement pour les générateurs de prospects",
            submit: "Soumettre"
        },
        principal_info: {
            principal_info: "Info du principal",
            add_principal_info: "Ajouter les info du principal",
            principal_no: "Numéro du principal",
            title: "Titre",
            ownership_percentage: "Pourcentage de propriété",
            basic_details: "Détails de base",
            first_name: "Prénom",
            middle_name: "Deuxième prénom",
            last_name: "Nom de famille",
            home_phone: "Téléphone résidentiel",
            cell_phone: "Téléphone cellulaire",
            email: "Adresse courriel",
            date_of_birth: "Date de naissance",
            previous_address: "Adresse précédente (si l'adresse actuelle date de moins de 2 ans)",
            identity_details: "Détails d'identité",
            id_verification_method: "Méthode de vérification d'identité",
            id_type: "Type d'identification",
            document_number: "Numéro de document",
            document_issue_date: "Date d'émission du document",
            document_expiry_date: "Date d'expiration du document",
            country_of_citizenship_1: "Pays de citoyenneté 1",
            country_of_citizenship_2: "Pays de citoyenneté 2",
            residency: "Résidence",
            residency_note: "Si le principal a la citoyenneté de plus de deux pays et que l'un d'eux est les États-Unis, assurez-vous de sélectionner les États-Unis pour le pays de citoyenneté 1 ou le pays de citoyenneté 2.",
        },
        other_merchant_info: {
            title: "Autres informations sur le commerçant",
            add_info: "Ajouter d'autres informations sur le commerçant",
            type: "Type",
            gst_tax_id: "Numéro de TPS",
            sin: "NAS",
            sin_number: "Numéro NAS",
            ownership_type: "Type de propriété",
            business_number: "Numéro Registration d'entreprise",
            mcc: "MCC",
            description_of_services_offered: "Description des services offerts",
            settlement_currency: "Devise de règlement",
            year_established: "Année d'établissement",
            ownership_months: "Mois de propriété",
            ownership_years: "Années de propriété",
            country_of_formation: "Pays formé en",
            country_of_primary_business_operations: "Pays des activités commerciales principales"
        },
        bank_account: {
            title: "Compte bancaire",
            add_info: "Ajouter des informations bancaires",
            billing_account: "Compte de facturation",
            bank_name: "Nom de banque",
            bank_type: "Type de banque",
            transit_number: "Numéro de transit",
            dda_account_number: "Numéro de compte de DD",
            city: "Ville",
            province: "Province",
            postal_code: "Code postal"
        },
        payroll_info: {
            title: "Compte bancaire",
            add_info: "Ajouter des informations bancaires",
            billing_account: "Compte de facturation",
            bank_name: "Nom de banque",
            bank_type: "Type de banque",
            transit_number: "Numéro de transit",
            dda_account_number: "Numéro de compte de DD",
            sin: "Numéro de péché",
            dob: "Date de naissance",
            hourly_wage: "Salaire horaire",
            annual_salary: "Salaire annuel",
            city: "Ville",
            province: "Province",
            postal_code: "Code postal"
        },
        financial_info: {
            title: "Informations financières",
            add_info: "Ajouter des informations financières",
            revenue_transactions: "Revenus et transactions",
            avg_transaction_amount: "Montant moyen de la transaction",
            highest_avg_ticket: "Transaction moyenne la plus élevée",
            highest_avg_ticket_frequency: "Fréquence de transaction moyenne la plus élevée",
            projected_monthly_card_sales: "Estimation des ventes de cartes mensuelles",
            company_annual_revenue: "Revenu annuel de l'entreprise",
            seasonal_months_closed: "Mois saisonniers fermés",
            seasonal_business: "Entreprise saisonnière ?",
            language_preferences: "Préférence de langue",
            back_office_service_language: "Langue du service de bureau",
            pos_service_language: "Langue du service PDV",
            card_acceptance_per_channel: "Acceptation des cartes (par type)",
            website: "Site web",
            card_present: "Carte présente (CP) %",
            card_not_present: "Carte non présente (CNP) %",
            internet: "Internet (INT) %",
            industry_type: "Type d'industrie",
            card_swipe_chip_percent_nuvei: "Card Swipe/Chip",
            ecomm_percent_nuvei: "EComm",
            moto_percent_nuvei: "MOTO/Keyed",
            save: "Enregistrer"
        },
        legal_info: {
            title: "Adresse légale",
        },
        shipping_legal_address: {
            title: "Adresse de livraison / légale",
            add_address: "Ajouter une adresse",
            other_address: "Autre adresse",
            address_type: "Type d'adresse",
            dba_name: "Nom de l'entreprise (ou nom du lieu)",
            contact_name: "Nom du contact",
            phone: "Téléphone",
            ext: "Ext",
            fax: "Fax",
            address: "Adresse",
            city: "Ville",
            province: "Province",
            postal_code: "Code postal"
        }
    }
}